<template>
  <div>
    <template v-if="mode === 'view'">
      <List
        v-if="itemCategory.subcategories.length > 0"
        table-classes="table is-fullwidth"
        :columns="columns"
        :data="itemCategory.subcategories"
        :page-length="10"
        :rows-clickable="false"
        :default-order="{ col: 'name', dir: 'asc' }"
      >
        <template slot="column-actions" slot-scope="{ row }">
          <a class="button is-small" @click.stop="edit(row)" title="Rediger">
            <span class="icon">
              <i class="fas fa-edit"/>
            </span>
          </a>
          <a class="button is-small" @click.stop="remove(row)" title="Slet">
            <span class="icon">
              <i class="fas fa-trash"/>
            </span>
          </a>
          <a class="button is-small" @click.stop="findItems(row)" title="Find varer">
            <span class="icon">
              <i class="fas fa-search" />
            </span>
          </a>
          <a class="button is-small" @click.stop="$emit('edit-subcategories', row)" title="Rediger underkategorier">
            <span class="icon">
                <i class="fas fa-list"/>
            </span>
          </a>
        </template>
      </List>
      <span v-else class="list-empty ml-1">Ingen underkategorier fundet</span>
    </template>
    <template v-else>
      <div class="tabs">
        <ul>
          <li v-for="locale in listLocales" :key="locale.id" :class="{'is-active': locale_id === locale.id}" @click.prevent="locale_id = locale.id">
            <a>
              {{ locale.name }}
              <span class="icon" v-if="!form.localizations?.find((localization) => localization.locale_id === locale.id && localization.key === 'name')">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>

      <div class="columns is-tablet mb-1">
        <form-field
          class="column"
          :error="error.localizations"
          label="Underkategori"
        >
          <input-text
            v-model="name"
            :error="error.name"
            @input="nameChanged"
          />
        </form-field>
      </div>
    </template>
    <div class="columns is-tablet my-2 ml-0">
      <template v-if="mode === 'view'">
        <button class="button is-primary" @click="create">
          Opret underkategori
        </button>
      </template>
      <template v-else>
        <button class="button is-danger" @click="view">
          Tilbage til oversigt
        </button>
        <button class="button is-primary ml-2" @click="save">
          {{ mode === 'create' ? 'Opret' : 'Gem' }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import List from "@/elements/list";
import {FormField, InputText} from '@elems/form'
import {mapGetters} from "vuex";

export default {
  components: {
    List,
    FormField,
    InputText,
  },
  props: {
    itemCategory: {
      type: Object,
      required: true,
    },
    updatingSubSubCategory: {
        type: Boolean,
        default: false,
    }
  },
  data() {
    return {
      form: {
        item_category_id: null,
        localizations: [],
        parent_id: null,
      },
      error: {},
      locale_id: null,
      name: '',
      mode: 'view',
      subcategory: null,
      columns: [
        { name: 'name', title: 'Underkategori', sortable: true, searchable: true, width: 80 },
        { name: 'created_at', hidden: true },
        {
          name: 'actions',
          title: '',
          sortable: false,
          searchable: false,
          classes: () => 'has-text-right',
          width: '20'
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'listLocales',
    ]),
  },
  watch: {
    locale_id() {
      this.updateName();
    },
    mode() {
      this.locale_id = this.listLocales[0].id;
      this.clearErrors();
    }
  },
  methods: {
    clearErrors() {
      this.error = {};
    },
    setMode(mode) {
      this.mode = mode;
    },
    view() {
      this.setMode('view');
    },
    create() {
      this.setMode('create');

      this.form = {
        localizations: [],
        item_category_id: this.updatingSubSubCategory ? null : this.itemCategory.id,
        parent_id: this.updatingSubSubCategory ? this.itemCategory.id : null,
      }
      this.updateName();
    },
    edit(row) {
      this.setMode('edit');

      this.subcategory = row;
      this.form = {
        item_category_id: this.updatingSubSubCategory ? null : this.itemCategory.id,
        localizations: this.subcategory.localizations,
        parent_id: this.updatingSubSubCategory ? this.itemCategory.id : null,
      };
      this.updateName();
    },
    save() {
      if (this.mode === 'create') {
        this.createSubcategory();
      } else {
        this.updateSubcategory();
      }
    },
    findItems(row) {
      this.$router.push({
        name: 'item.index',
        query: {
          'subcategory': row.id
        },
      });
    },
    async remove(row) {
      let inUse = false;

      await window.axios.get('/api/item-subcategories/' + row.id + '/in-use')
          .then(({data}) => {
              inUse = data;
          })
          .catch(error => {
              console.error(error);
          })

      if (inUse) {
          alert('Underkategorien kan ikke slettes, da den er i brug');
          return;
      }

      if (!confirm('Er du sikker på du vil slette ' + row.name + '?')) {
        return
      }

      window.axios.delete('/api/item-subcategories/' + row.id)
        .then(() => {
          this.$emit('updated')
          this.$store.dispatch('setSuccess', 'Underkategori blev slettet')
        })
        .catch(error => {
          this.$store.dispatch('setError', 'Underkategori kunne ikke slettes')
        })
    },
    updateSubcategory() {
      window.axios.put('/api/item-subcategories/' + this.subcategory.id, this.form)
          .then(({ data }) => {
            this.$store.dispatch('setSuccess', 'Underkategori blev opdateret')
            this.$emit('updated')
            this.subcategory = null;
            this.setMode('view');
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              this.error = error.response.data.errors
            }
          })
    },
    createSubcategory() {
      window.axios.post('/api/item-subcategories', this.form)
          .then(({ data }) => {
            this.$emit('updated')
            this.$store.dispatch('setSuccess', 'Underkategori blev oprettet')
            this.setMode('view');
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              this.error = error.response.data.errors
            }
          })
    },
    updateName() {
      const name = this.form.localizations.find((localization) => localization.locale_id === parseInt(this.locale_id) && localization.key === 'name');
      this.name = name ? name.value : '';
    },
    nameChanged() {
      if (this.name.trim() === '') {
        this.form.localizations = this.form.localizations.filter((localization) => !(localization.locale_id === parseInt(this.locale_id) && localization.key === 'name'));
        return;
      }

      const name = this.form.localizations.find((localization) => localization.locale_id === parseInt(this.locale_id) && localization.key === 'name');
      if (name) {
        name.value = this.name;
      } else {
        this.form.localizations.push({
          locale_id: parseInt(this.locale_id),
          key: 'name',
          value: this.name,
        });
      }
    }
  },
};
</script>

<style lang="postcss" scoped>

</style>
